import NightGraph from './container/NightGraphContainer'

export default NightGraph